const TOPIC_TO_CLASSES = {
  science: [
    "CHEM 1A - General Chemistry",
    "CHEM 1B - General Chemistry",
    "CHEM 30A - Introductory Chemistry",
    "ENGR 5 - Science of High Technology",
    "GEOG 1 - Physical Geography",
    "GEOL 1 - General Geology",
    "GEOL 3 - Planet Earth",
    "METR 12 - Global Warming: Science and Solutions",
    "NUFS 1A - Physical Science of Food",
     "MATH 1 - Mathematical Reasoning",
    "PHYS 1 - Elementary Physics",
    "PHYS 2A - Fundamentals of Physics",
    "PHYS 2B - Fundamentals of Physics",
     "BIOL 54 - Human Understanding",
       "RECL 15 - Human Life Span",
    "PHYS 50 - General Physics/Mechanics",
      "PH 15 - Human Life Span",
    "PHYS 51 - General Physics/Electricity and Magnetism",
    "PHYS 52 - General Physics/Waves, Light, Heat",
    "BIOL 10 - The Living World",
    "BIOL 20 - Ecological Biology",
    "BIOL 21 - Human Biology",
    "BIOL 30 - Principles of Biology I",
    "BIOL 31 - Principles of Biology II",
    "BIOL 65 - Human Anatomy",
    "BIOL 65O - Human Anatomy",
    "BIOL 66 - Human Physiology",
    "ENVS 10 - Life on a Changing Planet",
    "MICR 20 - General Bacteriology",
    "NUFS 16 - Science, Physiology, and Nutrition",
    "ENVS 1 - Introduction to Environmental Issues",
    "SCI 2 - Success in Science",
     "HUM 80 - Reading the World",
     "ASTR 10 - Descriptive Astronomy",
       "GEOL 6 - Geology of California",
       "GEOL 7 - Earth, Time and Life",
       "METR 10 - Weather and Climate",
       "MICR 20 - General Bacteriology",
       "GEOL 9 - Earth Disasters",
       "ANTH 12 - Introduction to Human Evolution"
  ],
  health: [
    "BIOL 21 - Human Biology",
    "BIOL 65 - Human Anatomy",
    "BIOL 65O - Human Anatomy",
    "BIOL 66 - Human Physiology",
    "NUFS 9 - Introduction to Human Nutrition",
    "NUFS 10 - Basic Life Skills",
    "NUFS 16 - Science, Physiology, and Nutrition",
    "PH 1 - Understanding Your Health",
    "PH 15 - Human Life Span",
    "KIN 69 - Stress Management: A Multidisciplinary Perspective",
    "BIOL 54 - Human Understanding",
    "RECL 15 - Human Life Span",
     "MICR 20 - General Bacteriology",
       "PH 67 - Introductory Health Statistics",
     "BIOL 30 - Principles of Biology I",
    "BIOL 31 - Principles of Biology II",
  ],
  math: [
    "CHAD 80 - Quantitative Analysis in Developmental Science",
    "CS 22A - Python for Everyone",
    "ESM 1 - Mathematical Reasoning",
    "ESM 9 - Mathematics and Logic for General Education",
    "ESM 10A - Mathematics in Art and Music",
    "ESM 10D - Probability, Data Science, Ethics, and You",
    "ESM 10P - Mathematics in Politics",
    "ESM 15 - Statway: Statistics-Concepts & Methods",
    "ESM 18A - College Algebra",
    "JS 15 - Introductory Statistics in Justice Studies",
    "LING 26 - Quantitative Reasoning in Linguistic Diversity",
    "MATH 1 - Mathematical Reasoning",
    "MATH 10 - Mathematics for General Education",
    "MATH 10A - Mathematics in Art and Music",
    "MATH 10D - Probability, Data Science, Ethics, and You",
    "MATH 10P - Mathematics in Politics",
    "MATH 12 - Number Systems",
    "MATH 15 - Statway: Statistics-Concepts & Methods",
    "MATH 18A - College Algebra",
    "MATH 19 - Precalculus",
    "MATH 30 - Calculus I",
    "MATH 30X - Calculus I",
    "MATH 31 - Calculus II",
    "MATH 31X - Calculus II",
    "MATH 32 - Calculus III",
    "MATH 32X - Calculus III",
    "MATH 70 - Mathematics for Business",
    "MATH 70X - Mathematics for Business",
    "MATH 71 - Calculus for Business and Aviation",
    "MATH 71X - Calculus for Business and Aviation",
    "PH 67 - Introductory Health Statistics",
    "PHIL 9 - Mathematics and Logic for General Education",
    "SOCI 15 - Statistical Applications in the Social Sciences",
    "SOCS 15 - Statistical Applications in the Social Sciences",
    "STAT 95 - Elementary Statistics",
    "UNVS 15 - Statway: Statistics-Concepts & Methods"
  ],

  engineering: [
    "ENGR 5 - Science of High Technology",
    "ENGR 10 - Introduction to Engineering",
    "ENGR 25 - The Digital World and Society",
      "PHYS 50 - General Physics/Mechanics",
  ],

  environment: [
    "ENVS 1 - Introduction to Environmental Issues",
    "ENVS 10 - Life on a Changing Planet",
    "GEOL 5 - Sustainability, Human Development, and the Earth",
    "SCED 5 - Sustainability, Human Development, and the Earth",
    "GEOL 6 - Geology of California",
    "METR 12 - Global Warming: Science and Solutions",
    "BIOL 20 - Ecological Biology",
    "BIOL 30 - Principles of Biology I",
    "BIOL 31 - Principles of Biology II",
    "GEOG 1 - Physical Geography",
    "GEOL 8 - The Age of the Dinosaurs",
    "GEOL 9 - Earth Disasters",
    "NUFS 1A - Physical Science of Food",
    "GEOL 7 - Earth, Time and Life",
    "METR 10 - Weather and Climate",
    "ANTH 12 - Introduction to Human Evolution"
  ],

  business: [
    "BUS3 12 - Managing My life",
    "ECON 1B - Principles of Economics: Microeconomics",
    "MATH 70 - Mathematics for Business",
    "MATH 70X - Mathematics for Business",
     "KIN 69 - Stress Management: A Multidisciplinary Perspective",
    "PSYC 1 - Introduction to Psychology",
      "POLS 4 - Introduction to International Relations",
    "MATH 71 - Calculus for Business and Aviation",
     "EDCO 4 - Personal, Academic and Career Exploration",
      "KIN 68 - Visual Representations of Sport in Popular Culture",
    "MATH 71X - Calculus for Business and Aviation",
    "STAT 95 - Elementary Statistics",
     "COMM 41 - Critical Decision Making",
      "MATH 71 - Calculus for Business and Aviation",
    "MATH 71X - Calculus for Business and Aviation",
    "CA 60 - Creativity Matters",
  ],

  social: [
    "CCS 30 - Race and Ethnicity in Public Space",
    "AFAM 25 - The Changing Majority: Power and Ethnicity in America",
     "COMM 74 - Fundamentals of Intercultural Communication",
    "AMS 11 - Visions of Democracy",
    "AFAM 22 - The Humanities in African American Culture",
     "AAS 159 - Asian American Media Representation and Popular Culture",
      "PHIL 66 - Introduction to Aesthetics",
      "AAS 25 - The Changing Majority: Power and Ethnicity in America",
    "ANTH 11 - Cultural Anthropology",
    "CHAD 75 - Imagination, Play and Adult Creativity",
    "CHAD 76 - Child Development Among Media and Emerging Technologies",
    "COMM 10 - Communication and Human Relationships",
    "CS 25 - The Digital World and Society",
    "ENGR 25 - The Digital World and Society",
     "ECON 1B - Principles of Economics: Microeconomics",
    "GEOG 10 - Cultural Geography",
     "ARTH 72 - Design in Society",
      "CA 95 - Introduction to Queer Arts",
       "MUSC 19 - Music in World Cultures",
        "CCS 25 - The Changing Majority: Power and Ethnicity in America",
    "GEOG 12 - World Regional Geography",
      "KIN 68 - Visual Representations of Sport in Popular Culture",
    "HIST 10B - Western Civilization",
    "JOUR 50 - Navigating the News",
    "JS 25 - Introduction to Human Rights and Justice",
      "ASIA 19 - Music in World Cultures",
    "LING 20 - Nature of Language",
    "LING 24 - Language Variation in Space, Time, & Culture",
      "SOCI 15 - Statistical Applications in the Social Sciences",
    "SOCS 15 - Statistical Applications in the Social Sciences",
    "MCOM 72 - Mass Communication and Society",
    "PH 15 - Human Life Span",
    "POLS 2 - Introduction to Comparative Politics",
    "POLS 4 - Introduction to International Relations",
    "POLS 15 - Essentials of U.S. & California Government",
    "PSYC 1 - Introduction to Psychology",
    "RECL 15 - Human Life Span",
    "SOCI 1 - Introduction to Sociology",
    "SOCI 80 - Social Problems",
    "AMS 10 - Stories that Make America",
    "HUM 10 - Honors Global Oral and Rhetorical Cultures",
    "COMM 45 - Media and Culture",
     "HUM 80 - Reading the World",
         "CA 60 - Creativity Matters",
       "RTVF 10 - The Art of Film",
     
  ],

  education: [
    "EDCO 4 - Personal, Academic and Career Exploration",
    "EDCO 4FY - Personal, Academic and Career Exploration",
    "CHAD 60 - Child Development",
      "PH 67 - Introductory Health Statistics",
       "KIN 69 - Stress Management: A Multidisciplinary Perspective",
      "MCOM 72 - Mass Communication and Society",
       "CHAD 75 - Imagination, Play and Adult Creativity",
         "SOCI 80 - Social Problems",
     "MATH 10 - Mathematics for General Education",
         "CA 60 - Creativity Matters",
    "CHAD 70 - Lifespan Development in a Global Context",
    "CHAD 80 - Quantitative Analysis in Developmental Science",
    "SCI 2 - Success in Science",
     "PHIL 9 - Mathematics and Logic for General Education",
    "BUS3 12 - Managing My life",
    "CHAD 76 - Child Development Among Media and Emerging Technologies",
    "ESM 9 - Mathematics and Logic for General Education"
  ],

  communication: [
    "CCS 74 - Public Address",
        "CA 60 - Creativity Matters",
    "COMM 20 - Public Speaking",
    "AAS 159 - Asian American Media Representation and Popular Culture",
    "COMM 20N - Public Speaking For Nonnative Speakers",
    "COMM 40 - Argumentation and Advocacy",
    "COMM 41 - Critical Decision Making",
    "COMM 45 - Media and Culture",
     "COMM 74 - Fundamentals of Intercultural Communication",
    "PSYC 1 - Introduction to Psychology",
    "COMM 74 - Fundamentals of Intercultural Communication",
    "MCOM 72 - Mass Communication and Society",
    "JOUR 50 - Navigating the News",
        "COMM 10 - Communication and Human Relationships",
    "RTVF 10 - The Art of Film",
       "LING 21 - Language and Thinking",
  ],

  law: [
    "POLS 20 - Controversial Legal Issues",
    "POLS 15 - Essentials of U.S. & California Government",
    "JS 25 - Introduction to Human Rights and Justice",
    "JS 15 - Introductory Statistics in Justice Studies",
     "JOUR 50 - Navigating the News",
    "PHIL 57 - Logic and Critical Reasoning"
  ],

  history: [
    "HIST 1A - World History to 1500",
     "ANTH 11 - Cultural Anthropology",
    "HIST 10B - Western Civilization",
    "HIST 15 - Essentials of U.S. History",
    "AFAM 134 - The Black Civil Rights Movements",
     "CA 95 - Introduction to Queer Arts",
      "ARTH 70A - Art History, Prehistoric to Medieval",
      "CCS 1 - Introduction to Chicana and Chicano Studies",
      "CCS 25 - The Changing Majority: Power and Ethnicity in America",
    "ARTH 70B - Art History, Renaissance to Modern",
     "ARTH 70C - Arts of Asia",
     "AFAM 158 - Race, Sport, Activism & Social Movements",
      "ARTH 72 - Design in Society",
    "AMS 1A - American Cultures to 1877",
     "MUSC 10D - Introduction to Hip Hop",
      "AMS 11 - Visions of Democracy",
     "ARTH 15 - Intro to Visual Culture",
    "AMS 1B - American Cultures 1877 to Present",
    "AMS 10 - Stories that Make America",
    "AAS 33A - Asian Americans in U.S. History I",
    "AAS 33B - Asian Americans in U.S. History II",
    "AAS 1 - Introduction to Asian American Studies",
    "AFAM 2A - African Americans and the Development of America's History and Government",
    "AFAM 2B - African Americans and the Development of America's History and Government",
    "CCS 10A - Mexican Americans and the Development of U.S. History and Government",
    "HUM 1B - Humanities Honors - Silk Roads & Water Ways",
    "HUM 2B - Honors - Modern World Cultures B",
    "AFAM 25 - The Changing Majority: Power and Ethnicity in America",
      "JS 25 - Introduction to Human Rights and Justice",
       "AAS 25 - The Changing Majority: Power and Ethnicity in America",
    "HUM 80 - Reading the World",
    "CCS 74 - Public Address",
    "HUM 10 - Honors Global Oral and Rhetorical Cultures",
    "AFAM 22 - The Humanities in African American Culture",
    "ANTH 13 - Archaeology",
    "HIST 50 - Historical Process: Understanding Historical Reasoning",
      "LING 24 - Language Variation in Space, Time, & Culture",
       "GEOL 3 - Planet Earth",
       "ANTH 12 - Introduction to Human Evolution"
  ],

  philosophy: [
    "PHIL 57 - Logic and Critical Reasoning",
    "PHIL 66 - Introduction to Aesthetics",
    "GERO 99 - Death, Dying and Religions",
    "PHIL 9 - Mathematics and Logic for General Education",
    "PHIL 12 - Philosophy of the Person",
    "HUM 99 - Death, Dying and Religions",
     "MATH 1 - Mathematical Reasoning",
     "RELS 99 - Death, Dying and Religions",
        "SCED 5 - Sustainability, Human Development, and the Earth",
       "CHAD 70 - Lifespan Development in a Global Context",
    "ENVS 1 - Introduction to Environmental Issues",
     "CA 95 - Introduction to Queer Arts",
    "HUM 80 - Reading the World",
    "METR 12 - Global Warming: Science and Solutions",
      "MATH 10D - Probability, Data Science, Ethics, and You",
    "ANTH 12 - Introduction to Human Evolution"
  ],

  computer: [
    "CS 22A - Python for Everyone",
    "CS 25 - The Digital World and Society",
      "MATH 10D - Probability, Data Science, Ethics, and You",
     "PHYS 23 - Animation Physics",
  ],

  psychology: [
    "PSYC 1 - Introduction to Psychology",
    "PSYC 2Q - Identity Development and Prejudice",
    "COMM 41 - Critical Decision Making",
     "KIN 69 - Stress Management: A Multidisciplinary Perspective",
       "LING 21 - Language and Thinking",
  ],

  politics: [
    "POLS 2 - Introduction to Comparative Politics",
    "MCOM 72 - Mass Communication and Society",
     "CCS 30 - Race and Ethnicity in Public Space",
       "SCED 5 - Sustainability, Human Development, and the Earth",
      "JS 25 - Introduction to Human Rights and Justice",
    "POLS 4 - Introduction to International Relations",
    "POLS 15 - Essentials of U.S. & California Government",
    "MATH 10P - Mathematics in Politics",
    "COMM 40 - Argumentation and Advocacy",
    "COMM 41 - Critical Decision Making",
     "JOUR 50 - Navigating the News",
       "SOCI 80 - Social Problems",
    "ENVS 1 - Introduction to Environmental Issues",
     "ARTH 72 - Design in Society",
     "POLS 20 - Controversial Legal Issues",
      "AMS 11 - Visions of Democracy",
      "GEOL 5 - Sustainability, Human Development, and the Earth",
      "METR 12 - Global Warming: Science and Solutions",
  ],

  art_design: [
    "ARTH 15 - Intro to Visual Culture",
    "ARTH 70A - Art History, Prehistoric to Medieval",
    "ARTH 70B - Art History, Renaissance to Modern",
    "ARTH 70C - Arts of Asia",
    "MATH 10A - Mathematics in Art and Music",
    "ASIA 70C - Arts of Asia",
    "ARTH 72 - Design in Society",
    "CA 95 - Introduction to Queer Arts",
      "ENGL 71 - Creative Writing",
    "DANC 10 - Dance Appreciation",
    "HUM 1A - Humanities Honors - Origins, Agriculture, Empire",
    "KIN 68 - Visual Representations of Sport in Popular Culture",
    "TA 5 - Acting",
    "TA 10 - Theatre Appreciation",
    "TA 13 - Great Comedies for Theatre",
    "TA 48 - Voice & Movement for the Actor",
    "TA 55 - Intro to Design for Theatre",
      "RTVF 10 - The Art of Film",
  ],

  music: [
    "MUSC 4A - Music Systems IVA",
    "MUSC 4B - Music Systems IVB",
    "MUSC 10A - Music Appreciation",
    "MUSC 10B - Introduction to Music",
    "DANC 10 - Dance Appreciation",
    "MUSC 10C - Pop and Rock in the U.S.",
    "MUSC 10D - Introduction to Hip Hop",
    "MUSC 19 - Music in World Cultures",
    "MATH 10A - Mathematics in Art and Music",
     "CA 95 - Introduction to Queer Arts",
    "ASIA 19 - Music in World Cultures",
    "MUSC 8 - The Artist’s Way"
  ],

  sports: [
    "KIN 68 - Visual Representations of Sport in Popular Culture",
    "KIN 69 - Stress Management: A Multidisciplinary Perspective",
    "AFAM 158 - Race, Sport, Activism & Social Movements",
  ],

  language: [
    "CHIN 1A - Elementary Chinese",
      "ASIA 19 - Music in World Cultures",
    "CHIN 1B - Elementary Chinese",
    "CHIN 25A - Intermediate Chinese",
    "CHIN 25B - Intermediate Chinese",
    "ENGL 1B - Argument and Analysis",
     "ARTH 70C - Arts of Asia",
    "ENGL 10 - Great Works of Literature",
    "ENGL 21 - Mystery and Detective Fiction",
    "ENGL 22 - Fantasy and Science Fiction",
    "ENGL 30 - Literature and the Environment",
    "ENGL 40 - Contemporary World Fiction",
    "ENGL 71 - Creative Writing",
    "ENGL 78 - Introduction to Shakespeare’s Drama",
    "FREN 1A - Elementary French",
       "ENGL 20 - The Graphic Novel",
    "FREN 1B - Elementary French",
    "FREN 25A - Intermediate French: Reading",
    "FREN 25B - Intermediate French: Writing",
    "GERM 1A - Elementary German",
    "GERM 1B - Elementary German",
    "GERM 25A - Intermediate German",
    "GERM 25B - Intermediate German",
    "PORT 1B - Elementary Portuguese II",
    "RELS 70 - Gods, Guns, Gurus, Grails-World Religion",
    "RELS 90 - Bible History and Literature",
    "RUSS 1A - Elementary Russian I",
    "RUSS 1B - Elementary Russian II",
     "ANTH 11 - Cultural Anthropology",
    "SPAN 1A - Elementary Spanish",
    "SPAN 1B - Elementary Spanish",
    "SPAN 20A - Spanish for Heritage Speakers I",
    "SPAN 20B - Spanish for Heritage Speakers II",
    "SPAN 25A - Intermediate Spanish",
    "SPAN 25B - Intermediate Spanish",
    "TAG 1A - Elementary Tagalog I",
    "TAG 1B - Elementary Tagalog II",
    "VIET 1A - Elementary Vietnamese",
    "VIET 1B - Elementary Vietnamese",
    "HEBR 1A - Elementary Hebrew",
    "LING 20 - Nature of Language",
    "LING 21 - Language and Thinking",
    "LING 22 - Language across the Lifespan",
    "LING 24 - Language Variation in Space, Time, & Culture",
    "LING 25 - Languages of the World",
    "LING 26 - Quantitative Reasoning in Linguistic Diversity"
  ],
  Writing: [
    "ENGL 1A - First Year Writing",
    "ENGL 1AF - First-Year Writing: Stretch English I",
    "ENGL 1B - Argument and Analysis",
    "ENGL 10 - Great Works of Literature",
    "ENGL 20 - The Graphic Novel",
    "ENGL 21 - Mystery and Detective Fiction",
    "ENGL 22 - Fantasy and Science Fiction",
    "ENGL 30 - Literature and the Environment",
    "ENGL 40 - Contemporary World Fiction",
    "ENGL 71 - Creative Writing",
    "ENGL 78 - Introduction to Shakespeare’s Drama"
  ]
};
export { TOPIC_TO_CLASSES };
